import { render, staticRenderFns } from "./text-image.vue?vue&type=template&id=10db83fd"
import script from "./text-image.vue?vue&type=script&lang=js"
export * from "./text-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports